let stoqReady =
  window._RestockRocket &&
  typeof window._RestockRocket.openModal === 'function';

const pendingStoqButtons = new Set();

function openStoqModal(button) {
  const api = window._RestockRocket;

  if (!api || typeof api.openModal !== 'function') {
    pendingStoqButtons.add(button);
    return;
  }

  try {
    const productData = JSON.parse(button.dataset.productJson);
    const variantId = String(button.dataset.variantId);

    api.openModal(productData, variantId);
  } catch (error) {
    console.error('Unable to open the STOQ notification form.', error);

    if (button.dataset.productUrl) {
      window.location.assign(button.dataset.productUrl);
    }
  }
}

window.addEventListener('stoq:loaded', (event) => {
  stoqReady =
    event.detail?.enabled !== false &&
    window._RestockRocket &&
    typeof window._RestockRocket.openModal === 'function';

  if (!stoqReady) return;

  pendingStoqButtons.forEach((button) => {
    openStoqModal(button);
  });

  pendingStoqButtons.clear();
});

document.addEventListener('click', (event) => {
  const notifyButton = event.target.closest('[data-ep-stoq-notify]');
  if (!notifyButton) return;

  event.preventDefault();
  event.stopPropagation();

  openStoqModal(notifyButton);
});

document.addEventListener('change', (event) => {
  const sortSelect = event.target.closest('[data-ep-sort]');
  if (!sortSelect) return;

  sortSelect.form?.requestSubmit();
});

